import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";
import BlogGrid from "../components/Blog/BlogGrid";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";

const BlogGridPage = () => {
    let { pageNumber } = useParams();
    const currentPage = parseInt(pageNumber, 10) || 1;

    const [BlogData, setBlogData] = useState({ Blogs: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/blogs.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to load blog data");
                }
                return response.json();
            })
            .then((data) => {
                setBlogData(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching blogs:", error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div className="text-center py-5">Loading blogs...</div>;
    }

    return (
        <div className="body_wrapper">
            <CustomNavbar
                slogo="sticky_logo"
                cClass="custom_container p0"
                mClass="menu_four"
                nClass="w_menu"
            />
            <Breadcrumb
                breadcrumbClass="breadcrumb_area"
                imgName="breadcrumb/banner_bg.png"
                Ptitle="Blogs"
                Pdescription="Why I say old chap that is spiffing off his nut arse pear shaped plastered Jeffrey bodge barney some dodgy.!!"
            />

            <BlogGrid BlogData={BlogData} currentPage={currentPage} />
            <FooterTwo FooterData={FooterData} />
        </div>
    );
};

export default BlogGridPage;